// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/index'
import BootstrapVue from 'bootstrap-vue'
import VueResource from 'vue-resource'
import Header from './pages/Shared/Header/Header'
import Loader from './pages/Shared/Loader/Loader'

Vue.component('app-header', Header)
Vue.component('app-loader', Loader)

Vue.use(BootstrapVue)
Vue.use(VueResource)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
	store,
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js